<template>
	<footer class="my-5 border-t border-[--schwarz-15] px-4 text-sm md:m-0 md:mb-4 md:mt-8 md:text-base">
		<div class="mt-4">Der EnergieKompass ist ein Service des Landes Salzburg.</div>

		<div class="mt-1 flex flex-wrap gap-x-2">
			<span>© Land Salzburg</span>
			|
			<a
				href="https://www.salzburg.gv.at/dienststellen/kontakt/datenschutz/energiekompass-datenschutz"
				target="_blank"
				class="underline hover:text-[--rot] hover:underline"
			>
				Impressum
			</a>
			|
			<a
				href="https://www.salzburg.gv.at/dienststellen/kontakt/datenschutz/energiekompass-datenschutz"
				target="_blank"
				class="underline hover:text-[--rot] hover:underline"
			>
				Rechtliche Hinweise
			</a>
			|
			<a
				href="https://www.salzburg.gv.at/dienststellen/kontakt/datenschutz/energiekompass-datenschutz"
				target="_blank"
				class="underline hover:text-[--rot] hover:underline"
			>
				Datenschutz
			</a>
		</div>
	</footer>
</template>
